export default __webpack_public_path__ + "static/media/voop.e457de94.wav";